// pages/TermsAndConditions.jsx
export default function TermsAndConditions() {
  return (
    <div className="max-w-3xl mx-auto p-6 font-sans text-primary">
      <h1 className="text-3xl font-heading font-bold mb-4">Terms & Conditions</h1>

      <p className="mb-4">
        These Terms & Conditions govern your use of the ZollowUp website and services.
      </p>

      <h2 className="text-xl font-heading font-semibold mt-6 mb-2">1. Acceptance of Terms</h2>
      <p>By using our platform, you agree to these terms and our privacy policy.</p>

      <h2 className="text-xl font-heading font-semibold mt-6 mb-2">2. Services</h2>
      <p>We provide home service bookings such as maid and nurse appointments.</p>

      <h2 className="text-xl font-heading font-semibold mt-6 mb-2">3. User Responsibilities</h2>
      <p>You must provide accurate information and not misuse our platform.</p>

      <h2 className="text-xl font-heading font-semibold mt-6 mb-2">4. Payments</h2>
      <p>All service payments are processed securely via our payment gateway partners.</p>

      <h2 className="text-xl font-heading font-semibold mt-6 mb-2">5. Modifications</h2>
      <p>We reserve the right to change these terms at any time with notice.</p>

      <h2 className="text-xl font-heading font-semibold mt-6 mb-2">6. Contact</h2>
      <p>
        If you have questions, contact us at <span className="text-accent">support@zollowup.com</span>.
      </p>
    </div>
  );

}
